class ArticleTiles extends HTMLElement {
    constructor() {
        super();

        this.readMoreButton = this.querySelector('.article-card__read-more-button');
        if (this.readMoreButton) this.readMoreButton.addEventListener('click', this.toggleReadMore.bind(this));
    }

    toggleReadMore(event) {
        const button = event.target;
        const isOpen = button
            .closest('.card__information')
            .querySelector('.article-card__read-more-wrapper')
            .classList.contains('article-card__read-more-wrapper--open');

        button.querySelector('.article-card__button-text').textContent = isOpen
            ? window.article.readMore
            : window.article.readLess;
        button.classList.toggle('article-card__read-more-button--open');
        button
            .closest('.card__information')
            .querySelector('.article-card__read-more-wrapper')
            .classList.toggle('article-card__read-more-wrapper--open');
    }
}

customElements.define('article-tile', ArticleTiles);
